import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    file: File,

}
export const useUploadMissingDoc = (onError: (errorMessage: string) => void) => {
  const { user: { customerId } } = useStore(state => state);

  return useMutation(
    'useUploadMissingDoc',
    async ({ file }: IProps) => {
      const formData = new FormData();
      formData.append('dbaDocument', file);
      const res = await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/dba/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return res.data;
    },
    {
      onError: (error: IServerErrorResponse) => {
        onError(error.response.data?.errors?.[0].localizedMessage || 'Something went wrong');
      },
    },
  );
};
